
import useScrollProgress from "../../app/hooks/useScrollProgress";

export default function ScrollProgress() {

    const progress = useScrollProgress();

    return (
        <div className="lg:w-[70%] mx-auto">
            <hr
                className="bg-[#1dcaff] rounded-md py-[2px] md:py-[3px]"
                style={{ width: `${progress}%` }}
            />
        </div>
    );
}